import React from 'react';
import { thesisInfo } from '../mock';

const Thesis = () => {
  return (
    <div className="min-h-screen bg-off-white py-20 px-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <span className="inline-block bg-burgundy text-off-white px-4 py-2 rounded-full text-sm font-semibold uppercase tracking-wider mb-4">
            {thesisInfo.status} • {thesisInfo.date}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-6">
            {thesisInfo.title}
          </h1>
          <div className="text-lg text-neutral-600">
            <p>{thesisInfo.venue}</p>
          </div>
        </div>

        {/* Hero Image */}
        <div className="aspect-video w-full rounded-lg overflow-hidden bg-warm-grey mb-12">
          <img
            src="https://customer-assets.emergentagent.com/job_art-study-space/artifacts/vi79ncbd_MamaAnna.jpg"
            alt="Mama Anna - Historical photograph"
            className="w-full h-full object-cover object-center"
          />
        </div>

        {/* Description */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            About the Work
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-neutral-700 leading-relaxed mb-6">
              {thesisInfo.description}
            </p>
          </div>
        </section>

        {/* Concept */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Concept
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-neutral-700 leading-relaxed">
              {thesisInfo.concept}
            </p>
          </div>
        </section>

        {/* Technical Details */}
        <section className="bg-warm-grey p-8 rounded-lg mb-12">
          <h3 className="text-xl font-semibold text-charcoal mb-4">Medium & Materials</h3>
          <p className="text-neutral-700 leading-relaxed">
            {thesisInfo.medium}
          </p>
        </section>

        {/* Key Questions */}
        <section>
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Central Questions
          </h2>
          <div className="space-y-4">
            <div className="bg-charcoal text-off-white p-6 rounded-lg">
              <p className="text-lg font-medium">What is the wake?</p>
            </div>
            <div className="bg-charcoal text-off-white p-6 rounded-lg">
              <p className="text-lg font-medium">What happens after the wake?</p>
            </div>
            <div className="bg-charcoal text-off-white p-6 rounded-lg">
              <p className="text-lg font-medium">How do we honor those who were lost to the wake?</p>
            </div>
            <div className="bg-charcoal text-off-white p-6 rounded-lg">
              <p className="text-lg font-medium">When do we become woke?</p>
            </div>
          </div>
        </section>

        {/* Note about Work in Progress */}
        <div className="mt-12 bg-burgundy/10 border-l-4 border-burgundy p-6 rounded">
          <p className="text-neutral-700">
            <strong className="text-charcoal">Note:</strong> This thesis exhibition is currently in development and will be presented in May 2026. Check back for updates, documentation, and exhibition details.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Thesis;